// frontend/src/components/CrearPresupuestoModal.jsx
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import contentService from '../services/contentService';
import presupuestosService from '../services/presupuestosService';
import './CrearModal.css';

const CrearPresupuestoModal = ({ onClose, onCreate, periodo }) => {
  const [equipos, setEquipos] = useState([]);
  const [cuentas, setCuentas] = useState([]);
  const [tab, setTab] = useState('existente'); // 'existente' or 'crear'
  const [creandoEquipo, setCreandoEquipo] = useState(false);
  const [nuevoEquipoForm, setNuevoEquipoForm] = useState({
    nombre_equipo: '',
    cuenta: '',
    status: 'activo'
  });
  const [formData, setFormData] = useState({
    cuenta: '',
    equipo: '',
    nombre_presupuesto: '',
    descripcion: '',
    periodo: periodo,
    presupuesto_consumido: 0,
    status: 'borrador'
  });

  useEffect(() => {
    cargarEquipos();
    cargarCuentas();
  }, []);

  const cargarEquipos = async () => {
    try {
      const response = await presupuestosService.getEquipos();
      console.log('🔍 getEquipos response:', response.data);

      let equiposData = [];

      // Manejar respuesta paginada de Django REST Framework
      if (response.data && response.data.results && Array.isArray(response.data.results)) {
        console.log('✅ Equipos (paginado):', response.data.results.length, 'equipos');
        equiposData = response.data.results;
      }
      // Manejar respuesta directa de array
      else if (Array.isArray(response.data)) {
        console.log('✅ Equipos (array directo):', response.data.length, 'equipos');
        equiposData = response.data;
      }
      // Error: estructura no reconocida
      else {
        console.warn('⚠️ Equipos estructura no reconocida:', response.data);
        equiposData = [];
      }

      setEquipos(equiposData);
    } catch (error) {
      console.error('❌ Error al cargar equipos:', error);
      toast.error('Error al cargar equipos');
      setEquipos([]);
    }
  };

  const cargarCuentas = async () => {
    try {
      const response = await contentService.getCuentas();
      console.log('🔍 getCuentas response:', response.data);
      // response.data tiene estructura: { success: true, cuentas: [...] }
      if (response.data && response.data.cuentas && Array.isArray(response.data.cuentas)) {
        setCuentas(response.data.cuentas);
      } else {
        console.warn('⚠️ Cuentas no es un array:', response.data);
        setCuentas([]);
      }
    } catch (error) {
      console.error('Error al cargar cuentas:', error);
      toast.error('Error al cargar cuentas');
      setCuentas([]);
    }
  };

  const crearNuevoEquipo = async () => {
    if (!nuevoEquipoForm.nombre_equipo.trim()) {
      toast.error('El nombre del equipo es requerido');
      return;
    }
    if (!nuevoEquipoForm.cuenta) {
      toast.error('Debes seleccionar una cuenta');
      return;
    }

    setCreandoEquipo(true);
    try {
      console.log('📝 Creando equipo:', nuevoEquipoForm);
      const response = await presupuestosService.createEquipo({
        nombre_equipo: nuevoEquipoForm.nombre_equipo,
        cuenta: parseInt(nuevoEquipoForm.cuenta),
        status: nuevoEquipoForm.status
      });

      console.log('✅ Equipo creado:', response.data);

      // Auto-select the newly created equipo y mantener la cuenta
      setFormData(prev => ({
        ...prev,
        cuenta: nuevoEquipoForm.cuenta,
        equipo: response.data.id.toString()
      }));

      // Reset the new equipo form and switch tab
      setNuevoEquipoForm({ nombre_equipo: '', cuenta: '', status: 'activo' });
      setTab('existente');

      // Reload equipos list
      console.log('🔄 Recargando equipos...');
      await cargarEquipos();

      toast.success('Equipo creado exitosamente');
    } catch (error) {
      console.error('❌ Error al crear equipo:', error);
      toast.error('Error al crear equipo');
    } finally {
      setCreandoEquipo(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.nombre_presupuesto.trim()) {
      toast.error('El nombre del presupuesto es requerido');
      return;
    }
    if (!formData.equipo) {
      toast.error('Debes seleccionar un equipo');
      return;
    }
    onCreate(formData);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => {
      const updated = {
        ...prev,
        [name]: value
      };
      // Si cambia la cuenta, limpiar el equipo seleccionado
      if (name === 'cuenta') {
        updated.equipo = '';
      }
      return updated;
    });
  };

  const handleNuevoEquipoChange = (e) => {
    const { name, value } = e.target;
    setNuevoEquipoForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Filtrar equipos por cuenta seleccionada
  const equiposFiltrados = formData.cuenta
    ? equipos.filter(equipo => equipo.cuenta === parseInt(formData.cuenta))
    : [];

  // Logging para debug
  useEffect(() => {
    console.log('📊 Equipos cargados:', equipos.length);
    console.log('📊 Cuenta seleccionada:', formData.cuenta);
    console.log('📊 Equipos filtrados:', equiposFiltrados.length);
  }, [equipos, formData.cuenta, equiposFiltrados]);

  return (
    <div className="crear-modal-overlay" onClick={onClose}>
      <div className="crear-modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>➕ Crear Nuevo Presupuesto</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          {/* Tabs para Equipo Existente / Crear Nuevo */}
          <div className="form-tabs">
            <button
              type="button"
              className={`tab-button ${tab === 'existente' ? 'active' : ''}`}
              onClick={() => setTab('existente')}
            >
              📋 Equipo Existente
            </button>
            <button
              type="button"
              className={`tab-button ${tab === 'crear' ? 'active' : ''}`}
              onClick={() => setTab('crear')}
            >
              ➕ Crear Nuevo Equipo
            </button>
          </div>

          {tab === 'existente' ? (
            <div>
              <div className="form-group">
                <label>Cuenta *</label>
                <select
                  name="cuenta"
                  value={formData.cuenta}
                  onChange={handleChange}
                  required
                >
                  <option value="">Seleccionar cuenta...</option>
                  {Array.isArray(cuentas) && cuentas.map(cuenta => (
                    <option key={cuenta.id} value={cuenta.id}>
                      {cuenta.nombre}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Equipo *</label>
                <select
                  name="equipo"
                  value={formData.equipo}
                  onChange={handleChange}
                  required
                  disabled={!formData.cuenta}
                >
                  <option value="">
                    {formData.cuenta
                      ? 'Seleccionar equipo...'
                      : 'Primero selecciona una cuenta'}
                  </option>
                  {Array.isArray(equiposFiltrados) && equiposFiltrados.map(equipo => (
                    <option key={equipo.id} value={equipo.id}>
                      {equipo.nombre_equipo}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          ) : (
            <div>
              <div className="form-group">
                <label>Nombre del Equipo *</label>
                <input
                  type="text"
                  name="nombre_equipo"
                  value={nuevoEquipoForm.nombre_equipo}
                  onChange={handleNuevoEquipoChange}
                  placeholder="Ej: Equipo Desarrollo, Equipo Ventas"
                  required
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Cuenta *</label>
                  <select
                    name="cuenta"
                    value={nuevoEquipoForm.cuenta}
                    onChange={handleNuevoEquipoChange}
                    required
                  >
                    <option value="">Seleccionar cuenta...</option>
                    {Array.isArray(cuentas) && cuentas.map(cuenta => (
                      <option key={cuenta.id} value={cuenta.id}>
                        {cuenta.nombre}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label>Status</label>
                  <select
                    name="status"
                    value={nuevoEquipoForm.status}
                    onChange={handleNuevoEquipoChange}
                  >
                    <option value="activo">Activo</option>
                    <option value="inactivo">Inactivo</option>
                  </select>
                </div>
              </div>

              <button
                type="button"
                className="btn btn-primary"
                onClick={crearNuevoEquipo}
                disabled={creandoEquipo}
                style={{ marginBottom: '1rem' }}
              >
                {creandoEquipo ? '⏳ Creando...' : '➕ Crear Equipo'}
              </button>
            </div>
          )}

          <div className="form-group">
            <label>Nombre del Presupuesto *</label>
            <input
              type="text"
              name="nombre_presupuesto"
              value={formData.nombre_presupuesto}
              onChange={handleChange}
              placeholder="Ej: Presupuesto Q1 2025"
              required
            />
          </div>

          <div className="form-group">
            <label>Descripción</label>
            <textarea
              name="descripcion"
              value={formData.descripcion}
              onChange={handleChange}
              placeholder="Descripción del presupuesto..."
              rows={3}
            ></textarea>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Período *</label>
              <select
                name="periodo"
                value={formData.periodo}
                onChange={handleChange}
              >
                <option value="2025">2025</option>
                <option value="2026">2026</option>
              </select>
            </div>

            <div className="form-group">
              <label>Presupuesto Consumido</label>
              <input
                type="number"
                name="presupuesto_consumido"
                value={formData.presupuesto_consumido}
                onChange={handleChange}
                min="0"
                step="0.01"
                placeholder="0"
              />
            </div>

            <div className="form-group">
              <label>Status</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
              >
                <option value="borrador">Borrador</option>
                <option value="activo">Activo</option>
                <option value="cerrado">Cerrado</option>
              </select>
            </div>
          </div>

          <div className="modal-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary">
              Crear Presupuesto
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CrearPresupuestoModal;
